import { useState, useEffect } from "react";
import styles from "./menuconfig.module.css";
import Sidebar from "../../Components/Sidebar";
import EmojiPicker from "../../Components/EmojiPicker";
import api from "../../api";

const FORM_SECAO_VAZIO = { idsec: "", label: "", icone: "", shortlabel: "", nav: true, ordem: 1 };
const FORM_ITEM_VAZIO  = { label: "", icone: "", destino: "" };

export default function MenuConfig() {
    const [secoes, setSecoes]               = useState([]);
    const [loading, setLoading]             = useState(false);
    const [secaoAtiva, setSecaoAtiva]       = useState(null);
    const [itens, setItens]                 = useState({});
    const [loadingItens, setLoadingItens]   = useState(false);

    const [formSecao, setFormSecao] = useState(null); // null | objeto
    const [formItem, setFormItem]   = useState(null); // null | objeto

    async function carregarSecoes() {
        try {
            setLoading(true);
            const res = await api.get("/portal/menu/secoes");
            const data = Array.isArray(res.data) ? res.data : [];
            setSecoes(data.sort((a, b) => a.ordem - b.ordem));
        } catch {
            alert("Erro ao carregar seções do menu.");
        } finally {
            setLoading(false);
        }
    }

    async function carregarItens(codsec) {
        try {
            setLoadingItens(true);
            const res = await api.get(`/portal/menu/itens?codsec=${codsec}`);
            setItens(prev => ({ ...prev, [codsec]: Array.isArray(res.data) ? res.data : [] }));
        } catch {
            setItens(prev => ({ ...prev, [codsec]: [] }));
        } finally {
            setLoadingItens(false);
        }
    }

    function selecionarSecao(codsec) {
        setSecaoAtiva(codsec);
        setFormItem(null);
        if (itens[codsec] === undefined) carregarItens(codsec);
    }

    async function salvarSecao() {
        if (!formSecao.label.trim()) return alert("Informe o nome da seção.");
        try {
            if (formSecao.codsec) {
                await api.put(`/portal/menu/secoes?codsec=${formSecao.codsec}`, formSecao);
            } else {
                await api.post("/portal/menu/secoes", formSecao);
            }
            setFormSecao(null);
            carregarSecoes();
        } catch (e) {
            alert("Erro ao salvar seção: " + e);
        }
    }

    async function excluirSecao(codsec) {
        if (!window.confirm("Excluir esta seção e todos os seus itens URL?")) return;
        try {
            await api.delete(`/portal/menu/secoes?codsec=${codsec}`);
            if (secaoAtiva === codsec) setSecaoAtiva(null);
            carregarSecoes();
        } catch (e) {
            alert("Erro ao excluir seção: " + e);
        }
    }

    async function salvarItem() {
        if (!formItem.label.trim() || !formItem.destino.trim()) return alert("Preencha nome e URL do item.");
        try {
            const payload = { ...formItem, tipo: "url", codsec: secaoAtiva };
            if (formItem.codite) {
                await api.put(`/portal/menu/itens?codite=${formItem.codite}`, payload);
            } else {
                await api.post("/portal/menu/itens", payload);
            }
            setFormItem(null);
            carregarItens(secaoAtiva);
        } catch (e) {
            alert("Erro ao salvar item: " + e);
        }
    }

    async function excluirItem(codite) {
        if (!window.confirm("Excluir este item?")) return;
        try {
            await api.delete(`/portal/menu/itens?codite=${codite}`);
            carregarItens(secaoAtiva);
        } catch (e) {
            alert("Erro ao excluir item: " + e);
        }
    }

    useEffect(() => { carregarSecoes(); }, []);

    const secaoSelecionada = secoes.find(s => s.codsec === secaoAtiva);
    const itensDaSecao     = secaoAtiva ? (itens[secaoAtiva] ?? []) : [];

    return (
        <div className={styles.layout}>
            <Sidebar />
            <div className={styles.main}>
                <div className={styles.content}>

                    {/* HEADER */}
                    <div className={styles.pageHeader}>
                        <div>
                            <span className={styles.pageLabel}>Configuração</span>
                            <h1 className={styles.pageTitle}>Menu do Aplicativo</h1>
                            <p className={styles.pageSubtitle}>Gerencie as seções e links externos exibidos no app dos colaboradores.</p>
                        </div>
                        <button
                            className={styles.btnNovo}
                            onClick={() => { setFormSecao({ ...FORM_SECAO_VAZIO, ordem: secoes.length + 1 }); }}
                        >
                            + Nova Seção
                        </button>
                    </div>

                    {/* FORM SEÇÃO */}
                    {formSecao && (
                        <div className={styles.formCard}>
                            <h3 className={styles.formTitulo}>
                                {formSecao.codsec ? "Editar Seção" : "Nova Seção"}
                            </h3>
                            <div className={styles.formGrid}>
                                <div className={styles.formGroup}>
                                    <label>Nome da seção</label>
                                    <input placeholder="ex: DP / RH" value={formSecao.label}
                                        onChange={e => setFormSecao(p => ({ ...p, label: e.target.value }))} />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>ID único</label>
                                    <input placeholder="ex: dp-rh" value={formSecao.idsec}
                                        onChange={e => setFormSecao(p => ({ ...p, idsec: e.target.value }))} />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Ícone (emoji)</label>
                                    <EmojiPicker
                                        value={formSecao.icone}
                                        onChange={v => setFormSecao(p => ({ ...p, icone: v }))}
                                    />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Label curto (menu inferior)</label>
                                    <input placeholder="DP/RH" value={formSecao.shortlabel}
                                        onChange={e => setFormSecao(p => ({ ...p, shortlabel: e.target.value }))} />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Ordem</label>
                                    <input type="number" min="1" value={formSecao.ordem}
                                        onChange={e => setFormSecao(p => ({ ...p, ordem: parseInt(e.target.value) || 1 }))} />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Aparece no menu inferior?</label>
                                    <div className={styles.toggleRow}>
                                        <input type="checkbox" id="nav-toggle" checked={formSecao.nav}
                                            onChange={e => setFormSecao(p => ({ ...p, nav: e.target.checked }))} />
                                        <label htmlFor="nav-toggle" className={styles.toggleLabel}>
                                            {formSecao.nav ? "Sim" : "Não"}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.formAcoes}>
                                <button className={styles.btnSalvar} onClick={salvarSecao}>Salvar seção</button>
                                <button className={styles.btnCancelar} onClick={() => setFormSecao(null)}>Cancelar</button>
                            </div>
                        </div>
                    )}

                    {/* PAINEL DOIS PAINÉIS */}
                    <div className={styles.painelGrid}>

                        {/* SEÇÕES */}
                        <div className={styles.secoesPanel}>
                            <div className={styles.panelHeader}>
                                <span>Seções</span>
                                <span className={styles.countBadge}>{secoes.length}</span>
                            </div>

                            {loading && <p className={styles.vazio}>Carregando...</p>}
                            {!loading && secoes.length === 0 && (
                                <p className={styles.vazio}>Nenhuma seção criada.</p>
                            )}

                            {secoes.map(s => (
                                <div
                                    key={s.codsec}
                                    className={`${styles.secaoItem} ${secaoAtiva === s.codsec ? styles.secaoItemAtivo : ""}`}
                                    onClick={() => selecionarSecao(s.codsec)}
                                >
                                    <div className={styles.secaoIcone}>{s.icone || "📋"}</div>
                                    <div className={styles.secaoInfo}>
                                        <strong>{s.label}</strong>
                                        <span>Ordem {s.ordem} · {s.nav ? "Nav ✓" : "Sem nav"}</span>
                                    </div>
                                    <div className={styles.secaoAcoes} onClick={e => e.stopPropagation()}>
                                        <button title="Editar" onClick={() => setFormSecao(s)}>✏️</button>
                                        <button title="Excluir" onClick={() => excluirSecao(s.codsec)}>🗑️</button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* ITENS */}
                        <div className={styles.itensPanel}>
                            {!secaoSelecionada && (
                                <div className={styles.vazioGrande}>
                                    <span>📋</span>
                                    <p>Selecione uma seção para gerenciar os itens.</p>
                                </div>
                            )}

                            {secaoSelecionada && (
                                <>
                                    <div className={styles.panelHeader}>
                                        <span>{secaoSelecionada.icone} {secaoSelecionada.label}</span>
                                        <button
                                            className={styles.btnAdicionarItem}
                                            onClick={() => setFormItem({ ...FORM_ITEM_VAZIO })}
                                        >
                                            + Adicionar link
                                        </button>
                                    </div>

                                    {/* FORM ITEM */}
                                    {formItem && (
                                        <div className={styles.formItemCard}>
                                            <h4>{formItem.codite ? "Editar item" : "Novo item"}</h4>
                                            <div className={styles.formGrid}>
                                                <div className={styles.formGroup}>
                                                    <label>Nome do item</label>
                                                    <input placeholder="ex: Meu Cadastro" value={formItem.label}
                                                        onChange={e => setFormItem(p => ({ ...p, label: e.target.value }))} />
                                                </div>
                                                <div className={styles.formGroup}>
                                                    <label>Ícone (emoji)</label>
                                                    <EmojiPicker
                                                        value={formItem.icone}
                                                        onChange={v => setFormItem(p => ({ ...p, icone: v }))}
                                                    />
                                                </div>
                                                <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                                                    <label>URL de destino</label>
                                                    <input
                                                        placeholder="https://... · use {toksim} e {cpffun} como variáveis"
                                                        value={formItem.destino}
                                                        onChange={e => setFormItem(p => ({ ...p, destino: e.target.value }))}
                                                    />
                                                    <small className={styles.hint}>
                                                        Variáveis disponíveis: <code>{"{toksim}"}</code> (token de acesso) · <code>{"{cpffun}"}</code> (CPF do colaborador)
                                                    </small>
                                                </div>
                                            </div>
                                            <div className={styles.formAcoes}>
                                                <button className={styles.btnSalvar} onClick={salvarItem}>Salvar item</button>
                                                <button className={styles.btnCancelar} onClick={() => setFormItem(null)}>Cancelar</button>
                                            </div>
                                        </div>
                                    )}

                                    {/* LISTA DE ITENS */}
                                    {loadingItens && <p className={styles.vazio}>Carregando itens...</p>}

                                    {!loadingItens && itensDaSecao.length === 0 && !formItem && (
                                        <p className={styles.vazio}>Nenhum item nesta seção.</p>
                                    )}

                                    <div className={styles.itensList}>
                                        {itensDaSecao.map(item => (
                                            <div
                                                key={item.codite}
                                                className={`${styles.itemRow} ${item.tipo === "rota" ? styles.itemRota : ""}`}
                                            >
                                                <span className={styles.itemIcone}>{item.icone || "🔗"}</span>
                                                <div className={styles.itemInfo}>
                                                    <strong>{item.label}</strong>
                                                    <span title={item.destino}>
                                                        {item.tipo === "rota" ? `→ ${item.destino}` : item.destino}
                                                    </span>
                                                </div>
                                                {item.tipo === "rota" ? (
                                                    <span className={styles.badgeRota}>🔒 Rota interna</span>
                                                ) : (
                                                    <div className={styles.itemAcoes}>
                                                        <button title="Editar" onClick={() => setFormItem(item)}>✏️</button>
                                                        <button title="Excluir" onClick={() => excluirItem(item.codite)}>🗑️</button>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
